import React, { Component } from 'react'

import classes from './SetupPosition.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm,
  extractFormData
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import Form from '../../../../components/PageContent/SetupData/SetupPosition/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ActionBar from '../../../../components/ActionBar/ActionBar'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import ImportModal from '../../../../components/ImportModal/ImportModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupPosition extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    importModalOpen: false,
    importFile: '',
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      position_code: {
        label: this.props.translate('code'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('code')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_name: {
        label: this.props.translate('positionName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('positionName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },

      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          type: 'text'
        },
        value: null,
        validation: {
          required: true,
          type: 'date'
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      position_id: {
        label: this.props.translate('positionName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('positionName'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('positionName')
            }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      filterCompany: this.props.filterCompany,
      filterPosition: this.props.filterPosition
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('position'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('position'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.position_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('position'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.position_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'position_code', title: this.props.translate('code'), type: 'string' },
    { field: 'position_name', title: this.props.translate('positionName'), type: 'string' },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    { field: 'effective_date', title: this.props.translate('effectiveDate'), type: 'string' }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchPosition()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.filterPosition !== updateProps.filterPosition) {
      updateFilter('position_id', 'filterPosition', [
        'position_id',
        { code: 'position_code', name: 'position_name' }
      ])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newPositionData = Object.entries(state.inputGroups).reduce((positionGroups, position) => {
        let [positionKey, positionAttrs] = position
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!positionAttrs.validation || !positionAttrs.validation.required) {
          valid = true
        }
        if (positionAttrs.elementType === 'checkbox') {
          value = 0
        } else if (positionAttrs.elementType === 'datePicker') {
          value = null
        }
        if (props.selectedRecord && props.selectedRecord[positionKey]) {
          value = props.selectedRecord[positionKey]
          if (positionAttrs.elementType === 'datePicker') {
            value = new Date(props.selectedRecord[positionKey])
          }

          let { isValid, error } = checkValidity(
            value,
            positionAttrs.validation,
            positionAttrs.label
          )
          if (positionAttrs.elementType === 'newselect') {
            value = state.inputGroups[positionKey].elementConfig.options.find(
              res => res.value === value
            )
          }
          valid = isValid
          errorMessage = error
        }

        const newPositionAttrs = {
          ...positionAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(positionGroups, { [positionKey]: { ...newPositionAttrs } })
      }, {})
      updatedState = {
        ...updatedState,
        inputGroups: newPositionData,
        formValid: true,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }
  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchPosition(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchPosition(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'effective_date':
          newFormAttrs = {
            ...formAttrs,
            value: null
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ inputGroups: newFormData })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchPositionById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true,
      formValid: false
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }

  downloadHandler = () => {
    this.props.downloadTemplate(this.state.filter)
  }

  exportHandler = () => {
    this.props.exportPosition(this.state.filter)
  }
  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: ''
    })
  }

  fileChangeHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  fileSubmitHandler = () => {
    this.props.importPosition(this.state.importFile, this.state.filter)
    this.closeImportModal()
  }

  positionSubmitHandler = type => {
    let positionData = extractFormData(this.state.inputGroups)

    if (this.state.action === 'add') {
      this.props.createPosition({ ...positionData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updatePosition(
        this.state.actionRecordId,
        { ...positionData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (groupKey, positionKey, event) => {
    const inputGroup = this.state.inputGroups
    const positionItem = inputGroup[positionKey]
    let inputValue = ''

    switch (positionItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = positionItem.value === 0 ? 1 : 0
        break
      case 'datePicker':
        inputValue = event
        break

      default:
        inputValue = event.target.value
        break
    }
    if (positionKey === 'appraisal_type_id') {
      this.props.fetchParentPositionOptions(inputValue.value)
    }
    const { isValid, error } = checkValidity(
      inputValue,
      positionItem.validation,
      positionItem.label
    )

    const updatedPositionItem = {
      ...positionItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [positionKey]: updatedPositionItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    this.setState({
      inputGroups: updateObject(this.state.inputGroups, { [positionKey]: updatedPositionItem }),
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = updateObject(filterControls, {
        [datakey]: { ...filterControls[datakey], value: '' }
      }))
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deletePosition(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]

    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchPosition(param)
    this.closeFilterModal()
  }

  render() {
    let positionLabel = <Spinner />

    if (!this.props.loading) {
      positionLabel = Object.entries(this.state.inputGroups).map((item, key) => {
        return (
          <Form
            key={key}
            form={item}
            inputChanged={(positionKey, e) => this.inputChangeHandler(key, positionKey, e)}
            formValid={this.state.formIsValid}
          />
        )
      })
    }
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.positionSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.positionSubmitHandler('save')}
        another={() => this.positionSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )

    let importDisabled = true
    const pagePermission = this.props.pagePermission

    if (pagePermission.is_add && pagePermission.is_edit) {
      importDisabled = false
    }

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <ImportModal
          title={this.props.translate('position')}
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.fileChangeHandler}
          fileSubmit={this.fileSubmitHandler}
          selectedFile={this.state.importFile}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('position')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{positionLabel}</div>
        </Modal>
        <Card>
          <CardHeader>
            <ActionBar
              exporting={this.exportHandler}
              importing={this.openImportModal}
              downloading={this.downloadHandler}
              filtering={this.openFilterModal}
              importDisabled={importDisabled}
            />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('position')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.position.pagination,
    data: state.position.records,
    loading: state.position.loading,
    filterLoading: state.position.filterLoading,
    success: state.position.success,
    selectedRecord: state.position.selectedRecord,
    companyOptions: state.position.company,
    positionGroupOptions: state.position.positionGroup,
    filterCompany: state.position.filterCompany,
    filterPosition: state.position.filterPosition,
    loadingQueue: state.position.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPosition: filterOptions => dispatch(actions.fetchPosition(filterOptions)),
    fetchPositionById: recordId => dispatch(actions.fetchPositionById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedPositionRecord()),
    createPosition: (recordData, page) => dispatch(actions.createPosition(recordData, page)),
    updatePosition: (recordId, recordData, page) =>
      dispatch(actions.updatePosition(recordId, recordData, page)),
    deletePosition: (recordId, page) => dispatch(actions.deletePosition(recordId, page)),
    importPosition: (importFile, filterOptions) =>
      dispatch(actions.importPosition(importFile, filterOptions)),
    exportPosition: filterOptions => dispatch(actions.exportPosition(filterOptions)),
    downloadTemplate: filterOptions => dispatch(actions.downloadPositionTemplate(filterOptions)),
    fetchCompanyOptions: recordId => dispatch(actions.fetchCompanyOptions(recordId)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchPositionGroupOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchCompanyOptions(filter))
      dispatch(actions.fetchPositionFilterPosition(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupPosition))
